import { Platform, Bridge } from "@xt/xtbase";

function dataUrlToBlob(dataUrl) {
  const parts = dataUrl.split(",");
  const mime = parts[0]?.match(/:(.*?);/)?.[1] || "image/png";
  const binary = atob(parts[1] || "");
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

function hasNativeMethod(name) {
  if (typeof window === "undefined") return false;
  try {
    const dsBridge = require("dsbridge");
    return dsBridge.hasNativeMethod(name);
  } catch {
    return false;
  }
}

function triggerAnchorDownload(dataUrl, filename) {
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

/**
 * 保存海报：App 内优先走原生 saveImage；移动端 H5 优先系统分享，失败则全屏预览长按保存。
 */
export async function savePosterImage(dataUrl, filename = "poster.png", options = {}) {
  if (!dataUrl || typeof window === "undefined") return;

  const showPreview = options.onMobilePreview || options.onIosPreview;

  if (Platform.isInApp()) {
    if (hasNativeMethod("saveImage")) {
      Bridge.call("saveImage", { imageBase64: dataUrl });
      return;
    }
    if (hasNativeMethod("savePhoto")) {
      Bridge.call("savePhoto", { imageBase64: dataUrl });
      return;
    }
    // App WebView 里如果没有保存能力，走分享面板通常会出现“保存到相册”但失败/无反馈。
    // 这里优先用「预览 + 长按保存」做稳定兜底。
    if (typeof showPreview === "function") {
      showPreview(dataUrl);
      return;
    }
    Bridge.share(dataUrl);
    return;
  }

  const isMobile = Platform.isIOS() || Platform.isAndroid();

  if (isMobile && typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      const blob = dataUrlToBlob(dataUrl);
      const file = new File([blob], filename, { type: blob.type || "image/png" });
      if (typeof navigator.canShare === "function" && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file] });
        return;
      }
    } catch (err) {
      if (err?.name === "AbortError") return;
    }
  }

  if (isMobile && typeof showPreview === "function") {
    showPreview(dataUrl);
    return;
  }

  triggerAnchorDownload(dataUrl, filename);
}
